export default "__VITE_ASSET__ZtsjlvTe__"